<template>
  <TextSetting
    :data="data"
    :disabled="disabled"
    show-placeholder
    :show-text-align="false"
    show-default-value
    default-value-type="textarea"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Widget } from '@/models'
import TextSetting from '../input/TextSetting.vue'

export default defineComponent({
  name: 'FaRemarkSetting',

  components: { TextSetting },

  props: {
    /** 控件数据 */
    data: {
      type: Widget,
      required: true
    },

    /** 是否禁用 */
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
</script>
